import { render, staticRenderFns } from "./ProjectsNavigationBar.vue?vue&type=template&id=5882fe74&scoped=true&"
import script from "./ProjectsNavigationBar.vue?vue&type=script&lang=js&"
export * from "./ProjectsNavigationBar.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsNavigationBar.vue?vue&type=style&index=0&id=5882fe74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5882fe74",
  null
  
)

export default component.exports